import styled from '@emotion/styled';

const Flex = styled.div`
  display: flex;
  align-items: center;
`;
const SpaceBetween = styled(Flex)`
  width: 100%;
  justify-content: space-between;
`;
const FlexStyled = {
  Flex,
  SpaceBetween,
};
export default FlexStyled;
